import React from "react";

const HeartBroken = props => (
  <svg viewBox="0 0 73 64" fill="none" {...props}>
    <path
      d="M67.016 6.406l-.282-.281c-6.468-6.61-16.593-7.313-23.906-2.11L47.75 18.5l-13.5 9 6.75 18-20.25-20.25 13.5-9-4.078-12.094C22.859-1.187 12.734-.625 6.125 6.125l-.281.281c-6.89 7.032-7.172 18.14-.985 25.594l29.813 30.797a2.462 2.462 0 003.516 0L68.14 32c6.046-7.453 5.765-18.563-1.125-25.594z"
      fill="#FFC1C1"
    />
  </svg>
);

export default HeartBroken;
